/* @license react-google-recaptcha-ultimate v1.2.2 */
var e=function(e){var t=document.getElementById(e);if(t)for(;t.lastChild;)t.lastChild.remove()};export{e as removeGoogleReCaptchaContainer};
//# sourceMappingURL=removeGoogleReCaptchaContainer.js.map
